import { graphql } from 'gatsby'
import React from 'react'

import WaitingListPage from '../containers/WaitingListPage'

const WaitingPage = ({ data }) => {
  return <WaitingListPage {...data.portal} />
}

export default WaitingPage

export const query = graphql`
  query WaitingPageQuery ($firebaseId: String) {
    portal(firebaseId: {eq: $firebaseId}) {
      ...PartialPortalData
    }
  }
`
